export default "__VITE_ASSET__UCFsL74P__"